import { render, staticRenderFns } from "./FavoriteView.vue?vue&type=template&id=63072b9b"
import script from "./FavoriteView.vue?vue&type=script&lang=js"
export * from "./FavoriteView.vue?vue&type=script&lang=js"
import style0 from "./FavoriteView.vue?vue&type=style&index=0&id=63072b9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports